
export function OfferStackSection() {
  const stackItems = [
    {
      title: 'Curso Método ScaleUp',
      value: '$97',
      icon: 'ri-graduation-cap-line',
    },
    {
      title: 'Pack de Prompts de Ventas',
      value: '$47',
      icon: 'ri-chat-3-line',
    },
    {
      title: 'Plantillas de Embudos',
      value: '$197',
      icon: 'ri-layout-line',
    },
    {
      title: 'Acceso a Comunidad Skool',
      value: 'Invaluable',
      icon: 'ri-team-line',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-yellow-400/20 border border-yellow-400/30 mb-4 sm:mb-6">
            <i className="ri-gift-line text-yellow-400 text-lg sm:text-xl"></i>
            <span className="text-yellow-400 font-bold text-xs sm:text-sm lg:text-base">TODO LO QUE RECIBES HOY</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-white mb-3 sm:mb-4">
            La Oferta Más <span className="text-yellow-400">Completa</span> del Mercado
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg">
            Esto es lo que obtienes cuando te unes hoy
          </p>
        </div>

        <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 xl:p-12 border-2 border-white/20 shadow-2xl">
          <div className="space-y-3 sm:space-y-4 lg:space-y-6">
            {stackItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 sm:p-4 lg:p-6 rounded-xl sm:rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 group"
              >
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0">
                    <i className={`${item.icon} text-white text-lg sm:text-xl lg:text-2xl xl:text-3xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-sm sm:text-base lg:text-lg xl:text-xl">{item.title}</h3>
                    <div className="flex items-center gap-1 sm:gap-2 mt-0.5 sm:mt-1">
                      <i className="ri-check-line text-emerald-400 text-xs sm:text-sm"></i>
                      <span className="text-emerald-400 text-[10px] sm:text-xs lg:text-sm">Incluido</span>
                    </div>
                  </div>
                </div>
                <div className="text-right flex-shrink-0 ml-2">
                  <div className="text-white/60 line-through text-[10px] sm:text-xs lg:text-sm xl:text-base">Valor:</div>
                  <div className="text-yellow-400 font-bold text-base sm:text-lg lg:text-2xl xl:text-3xl">{item.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t-2 border-white/20">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-center sm:text-left">
                <div className="text-white/60 text-xs sm:text-sm lg:text-base mb-1">Valor Total:</div>
                <div className="text-white/40 line-through text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold">$500</div>
              </div>
              <div className="text-center sm:text-right">
                <div className="text-yellow-400 text-xs sm:text-sm lg:text-base mb-1 font-semibold">🔥 Precio de Hoy:</div>
                <div className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 bg-clip-text text-transparent animate-pulse">
                  $20
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-8 p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-yellow-400/20 to-orange-400/20 border-2 border-yellow-400/30">
            <div className="flex items-start gap-2 sm:gap-3">
              <i className="ri-alarm-warning-line text-yellow-400 text-xl sm:text-2xl mt-0.5 sm:mt-1 flex-shrink-0"></i>
              <div>
                <h4 className="text-white font-bold text-sm sm:text-base lg:text-lg mb-1 sm:mb-2">⚡ Advertencia Importante</h4>
                <p className="text-white/90 text-xs sm:text-sm lg:text-base leading-relaxed">
                  Este precio de $20 es solo para los primeros 50 estudiantes. Una vez que se llenen los cupos, 
                  el precio volverá a $47 sin previo aviso. No pierdas esta oportunidad única.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
